/**
 * Show Formatter.
 * @param {*} value
 * @returns {string}
 */
window.showFormatter = function(value) {
    let html = '';
    html += '<a href="'+value+'">';
    html += '<i class="fontawesome fa fa-eye"></i>';
    html += '</a>';
    return html;
}
